import DirectoryProfileNavigation from './DirectoryProfileNavigation';

export default DirectoryProfileNavigation;
